import { render, staticRenderFns } from "./TerminationTypeList.vue?vue&type=template&id=06fa7bae&scoped=true"
import script from "./TerminationTypeList.vue?vue&type=script&lang=js"
export * from "./TerminationTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fa7bae",
  null
  
)

export default component.exports